import { Box } from 'rebass';
import PropTypes from 'prop-types';
import React from 'react';
import dynamic from 'next/dynamic';

const DynamicQuill = dynamic(() => import('react-quill'), { ssr: false });

const TextMedium = ({ medium }) => {
  return (
    <Box className="quill ql-lifetales" py={2}>
      <DynamicQuill readOnly value={medium.text} theme="bubble" />
    </Box>
  );
};

TextMedium.propTypes = {
  medium: PropTypes.shape({ text: PropTypes.string }).isRequired,
};

export default TextMedium;
